import { connect } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';

import { CostReviewModal } from '../../components/modals/cost-review-modal';
import { selectBulkCostReview, selectBulkJobByJobGuid, selectBulkShipDate } from '../../store/bulk/bulk.selectors';
import * as PostagePurchaseActions from '../../store/postage-purchase/postage-purchase.actions';
import * as BulkPurchaseActions from '../../store/bulk/purchase/bulk.purchase.actions';
import { bulkSetShipDate } from '../../store/bulk/bulk.actions';
import { CostReviewBaseContainer } from './cost-review-base-container';
import { CostReviewHelperService } from '../../services/cost-review-helper-service';
import { bulkCostReviewApplyRecommendations } from '../../store/bulk/cost-review/bulk.cost-review.actions';

const getCostReviewData = (costReviewFromJob, costReviewFromProps) => {
  if (costReviewFromJob) {
    return costReviewFromJob;
  }

  if (costReviewFromProps) {
    return CostReviewHelperService.mergeWalletProviders(costReviewFromProps);
  }

  return emptyObject;
};

const mapStateToProps = (state, props) => {
  const { jobGuid, readOnlyCostReviewModal, costReviewData: costReviewDataFromProps, fulfillmentPlanIds } = props;

  const { costReviewData: costReviewDataFromJob, recommendationSummary } = selectBulkJobByJobGuid(state, { jobGuid }) || {};

  const costReviewData = getCostReviewData(costReviewDataFromJob, costReviewDataFromProps);

  const { isLoading: isLoadingCostReview, isApplyingRecommendations, appliedSavings } = selectBulkCostReview(state) || {};

  const hasCostReviewData = Boolean(costReviewData && Object.keys(costReviewData).length);

  const {
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipDate,
    shipFromCount,
  } = CostReviewBaseContainer(costReviewData, state);

  const { upsTermsRequired } = costReviewData ?? {};

  return {
    shipDate: selectBulkShipDate(state) || shipDate,
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipFromCount,
    readOnlyCostReviewModal,
    isLoadingCostReview: isLoadingCostReview || !hasCostReviewData,
    recommendationSummary,
    totalAppliedSavings: appliedSavings,
    isApplyingRecommendations,
    fulfillmentPlanIds,
    upsTermsRequired,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { jobGuid } = props;
  return {
    purchasePostage: (providers, insurances, wallets, tracking, onAddFundsComplete, closeModal) => {
      dispatch(
        PostagePurchaseActions.postageAndInsurancePurchaseRequest(
          jobGuid,
          providers,
          insurances,
          wallets,
          tracking,
          onAddFundsComplete,
          closeModal,
        ),
      );
    },
    deferPostagePurchase: () => dispatch(PostagePurchaseActions.postagePurchaseDeferred(jobGuid, props.costReviewData)),
    walletPurchaseAmountChanged: (walletId, amount) => dispatch(BulkPurchaseActions.walletPurchaseAmountChanged(jobGuid, walletId, amount)),
    providerPurchaseAmountChanged: (provider, amount) =>
      dispatch(BulkPurchaseActions.providerPurchaseAmountChanged(jobGuid, provider, amount)),
    insurancePurchaseAmountChanged: (provider, amount) =>
      dispatch(BulkPurchaseActions.insurancePurchaseAmountChanged(jobGuid, provider, amount)),
    onShipDateChanged: (shipDate) => dispatch(bulkSetShipDate(shipDate)),
    closeOrderDetailsModal: () => dispatch(PostagePurchaseActions.closeOpenedModalsModals()),
    applyRecommendations: (bulkUpdateJobGuid, serviceFilters, insuranceFilters, rateShopperFilters, isRateShopperRecommendationsEnabled) =>
      dispatch(
        bulkCostReviewApplyRecommendations({
          costReviewJobGuid: jobGuid,
          bulkUpdateJobGuid,
          serviceFilters,
          insuranceFilters,
          rateShopperFilters,
          isRateShopperRecommendationsEnabled,
        }),
      ),
  };
};

export const CostReviewModalContainer = connect(mapStateToProps, mapDispatchToProps)(CostReviewModal);
